import React from 'react';
import { TextLink } from "@vds/buttons";
import styled from 'styled-components';
import { convertStringToElements } from '@vds/html-parsers';
import { isMobile, isMoversFlow, isVHILiteFlow, getSession, istgwRestrictBetaCustomersFFlag, isVHILitePlusFFlag, checkOnly5GHomePlan } from "../../common/Helpers";
import {
  DISNEY_GOOGLE_AI_REQUIRED_SED_OFFER_IDS,
  VHI_LITE_PLAN_NAME,
  WI_FI_Backup,
} from '../../common/Helpers/constants';

const AccrdnHeader = styled.div`
  font-weight: 1.5em,
  font-size: 15px;
  color: black;
`;

const AccrdnBody = styled.div`
  font-size: 0.75rem;
  line-height: 1rem;
  font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif;
  color: black;
`;

const AccrdnSubHeader = styled.div`
  fontSize: 12px;
  color: grey;
`;

export const createExtrasObject = ({
  overallNodes,
  getColorTheme,
  headerTheme,
  primary_Image,
  promoListCommon,
  promoItemList,
  parseHTML,
  promoItemListChoice,
  planPromosChoice,
  planPromosnonchoice,
  planExtrasRedesignFFlag,
  holidayPlansFFlag,
}) => {
  if (!overallNodes || !Object.keys(overallNodes)?.length > 0) {
    return null;
  }
  return {
    'data-track': JSON.stringify({
      name: overallNodes?.AccordLabel,
      data: { page: { detail: 'plans accordion' } },
    }),
    header: {
        badge: {
          children: overallNodes?.AccordLabel,
          fillColor: getColorTheme() ? '' : headerTheme,
        },
      ...(primary_Image &&
        primary_Image !== '-NA-' && {
          image: {
            src: primary_Image !== '-NA-' && primary_Image,
          },
        }),
      title: {
        ...(!holidayPlansFFlag && {
          children: parseHTML ? parseHTML(overallNodes?.AccordTitle) : overallNodes?.AccordTitle,
        }),
        ...(holidayPlansFFlag && {
          children: (
            <>      
              {planPromosChoice?.length > 0 && (
                <div className='choiceWrapper'>
                  <div className='contentHead' role="heading" aria-level="3">{overallNodes?.choiceLabel}</div>
                  {planPromosChoice}
                </div>
              )}
              {planPromosnonchoice?.length > 0 && (
                <>
                  <div className='contentHeadStack' role="heading" aria-level="3">{overallNodes?.IncludedLabel}</div>
                  {planPromosnonchoice}
                </>
              )}
              <div className='ContentAccordFooter'>{overallNodes?.AccordFooter}</div>
            </>
          ),
        }),
      },
    },
    content: [
      {
        items: promoListCommon,
      },
      ...(planExtrasRedesignFFlag ? [{
        title: {
          children: promoItemList && promoItemList.length > 0 ? 'Included with this plan:' : '',
        },
        helperText: {
          children: !promoItemListChoice ? overallNodes?.AccordFooter : '',

        },
        items: promoItemList,
      }] : []),
      {
        title: {
          children: overallNodes?.choiceLabel,
        },
        helperText: {
          children: overallNodes?.AccordFooter,
        },
        items: planExtrasRedesignFFlag ? promoItemListChoice : promoItemList,
      },
    ],
  };
};

export const createPromoItemListChoice = (
  badgeArrayChoice,
  setShowReviewDetailsOverlay,
  setReviewDetailsBadgeToolipUrl,
  setReviewDetailtoolTip
) => 
  badgeArrayChoice?.map(
    (item, index) =>
      item && {
        title: {
          children: (<div>{item?.itemHeader}<sup>{item?.superScript}</sup></div>),
        },
        subtitle: {
          children: (
            <div className='bgGrayLight'>
              {item?.itemSubHeader}
              <TextLink
                data-testId="reviewplanExtra"
                id="reviewplanExtra"
                ariaLabel={`${item?.itemHeader} details`}
                data-track={JSON.stringify({
                type: 'link',
                name: `${'special gift details'} | ${item?.itemHeader}`,
                data: { page: { detail: `${'special gift details'} | ${item?.itemHeader} modal` } },
                })}
                onClick={() => {
                  setShowReviewDetailsOverlay(true);
                  setReviewDetailsBadgeToolipUrl(item?.overlayURL);
                  setReviewDetailtoolTip(item?.itemOverlayContent);
                }}
              >
                {'  Details'}
              </TextLink>
              {index !== badgeArrayChoice.length - 1 && <div className='padding-class'> OR </div>}
            </div>
          ),
        },
      },
  );

export const createPairedFooterNotes = (footerNoteSS, FooterNote) => {
  const pairedFooterNotes = [];
  const existingKeys = new Set();
  
  if (Array.isArray(footerNoteSS) && Array.isArray(FooterNote)) {
    const minLength = Math.min(footerNoteSS.length, FooterNote.length);
    
    for (let i = 0; i < minLength; i++) {
      if (footerNoteSS[i] && FooterNote[i] && 
          footerNoteSS[i] !== '-NA-' && FooterNote[i] !== '-NA-') {
        
        if (!existingKeys.has(footerNoteSS[i])) {
          const pairObject = {};
          pairObject[footerNoteSS[i]] = FooterNote[i];
          pairedFooterNotes.push(pairObject);
          
          existingKeys.add(footerNoteSS[i]);
        }
      }
    }
  }
  
  return pairedFooterNotes;
}

export const getDisneyAndGoogleAIPerkPromotions = (availablePromotions = []) => {
  const filteredPerkPromotions = availablePromotions.filter(
    (promo) =>
      promo?.promoType === 'PERK' &&
      Array.isArray(promo?.badgeMessages) &&
      promo.badgeMessages.length > 0 &&
      DISNEY_GOOGLE_AI_REQUIRED_SED_OFFER_IDS.includes(String(promo?.sedOfferId)),
  );
  const responseSedOfferIds = new Set(filteredPerkPromotions.map((promo) => String(promo?.sedOfferId)));
  const hasBothSedOfferIds = DISNEY_GOOGLE_AI_REQUIRED_SED_OFFER_IDS.every((offerId) => responseSedOfferIds.has(offerId));

  return hasBothSedOfferIds ? filteredPerkPromotions : [];
};

export const getBestValueText = (isUltimatePlan, FFlag) => {
  if (isUltimatePlan && FFlag) {
    return 'Best Value';
  }
  return '';
};

export const getMoversTileClassName = (plans) => (!isMobile() && isMoversFlow() && plans?.length === 1) ? { className: 'moversSinglePlanStyles' } : {};

export const getVHILiteTileClassName = (plans) => {
  if (isVHILitePlusFFlag()) {
    // New logic: with plans parameter and length check
    return (!isMobile() && !isMoversFlow() && isVHILiteFlow() && plans && plans?.length <= 1) ? { className: 'vhiLitePlanTileWidth' } : {};
  }
  // Old logic: without plans parameter and length check
  return (!isMobile() && !isMoversFlow() && isVHILiteFlow()) ? { className: 'vhiLitePlanTileWidth' } : {};
};

export const getTGWBetaTileClassName = (plans) => {
  if (checkOnly5GHomePlan()) {
    return (!isMobile() && plans?.length === 1) ? { className: 'tgwSinglePlanStyles' } : {};
  }
  return (!isMobile() && getSession('isTGW') && istgwRestrictBetaCustomersFFlag() && plans?.length === 1) ? { className: 'tgwSinglePlanStyles' } : {};
}

export const getPlanName = (displayName) => {
  const planNames = ['LTE', WI_FI_Backup, '5G', VHI_LITE_PLAN_NAME];
  return planNames.find((name) => displayName?.includes(name)) || '';
};

export const getSixDayHolidayOfferInfo = (props) => {
  let offerProps = [];
  offerProps = props?.length > 0 && props?.map((offer) => ({
          variant: 'plan',
          header: {
              title: {
                  children: <>
                      <AccrdnHeader><b>{offer?.OfferHeader}</b></AccrdnHeader>
                      <AccrdnSubHeader>{offer?.retailvalue}</AccrdnSubHeader>
                  </>,
              },
              image: {
                  src: offer?.imagURL,
                  style: {
                    width: '5.25em',
                    height: '3.375em',
                },
              },
          },
          content: [{
              items: [{
              title: {
                  children: "",
              },
              subtitle: {
                  children: <>
                      <AccrdnBody>{convertStringToElements(offer?.shortDescription || '')}</AccrdnBody>
                      <div style={{ marginTop: '15px'}}>{offer?.offerDescription}</div>
                  </>,
                },
              }],
          }],
      }));
  return offerProps;
};